import * as ActionTypes from '../actions/ActionTypes';
import TemplateSettingsUpdateStatusRecord from '../records/TemplateSettingsUpdateStatusRecord';
const INITIAL_STATE = new TemplateSettingsUpdateStatusRecord();
export default function templateSettingsUpdateStatus(state = INITIAL_STATE, {
  error,
  payload,
  type
}) {
  switch (type) {
    case ActionTypes.FETCH_TEMPLATE_SETTINGS_SUCCESS:
      return state.merge({
        isUpdating: false,
        // @ts-expect-error ts-migrate(2322) FIXME: Type 'number' is not assignable to type 'null | un... Remove this comment to see the full error message
        lastUpdated: Math.max(payload.knowledgeBase.updated, payload.themeSettingsValues.updated),
        error: undefined
      });
    case ActionTypes.UPDATE_TEMPLATE_SETTINGS_PENDING:
      return state.merge({
        isUpdating: true,
        error: undefined
      });
    case ActionTypes.UPDATE_TEMPLATE_SETTINGS_SUCCESS:
      return state.merge({
        isUpdating: false,
        // @ts-expect-error ts-migrate(2322) FIXME: Type 'number' is not assignable to type 'null | un... Remove this comment to see the full error message
        lastUpdated: new Date().valueOf(),
        error: undefined
      });
    case ActionTypes.UPDATE_TEMPLATE_SETTINGS_ERROR:
      return state.merge({
        isUpdating: false,
        error
      });
    default:
      return state;
  }
}